import {
  COLOR_CALM,
  COLOR_DANGER,
  COLOR_GRAY_200,
  COLOR_GRAY_600,
  COLOR_INFO,
  COLOR_PRIMARY,
  COLOR_SUCCESS,
  COLOR_WARNING,
} from '../../config/constants';

// eslint-disable-next-line import/prefer-default-export
export const BADGE_TYPES = [
  COLOR_CALM,
  COLOR_DANGER,
  COLOR_GRAY_200,
  COLOR_GRAY_600,
  COLOR_PRIMARY,
  COLOR_INFO,
  COLOR_SUCCESS,
  COLOR_WARNING,
];
